const MAX_WIDTH = {
    AUTHENTICATION: 310,
    SETTINGS: 400,
}

export default MAX_WIDTH;